var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuotemarksLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 63.999,
    height: 45.176,
    viewBox: "0 0 63.999 45.176",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#cbe5fc;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.001 -9.412)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M50.629,26.226c-.129-1.393-.03-5.182,3.6-10.449a1,1,0,0,0-.116-1.274c-1.479-1.479-2.4-2.413-3.038-3.066-.845-.861-1.23-1.254-1.795-1.766a1,1,0,0,0-1.328-.013,38.326,38.326,0,0,0-12.334,30.81c.6,8.182,6.563,14.12,14.189,14.12a14.193,14.193,0,0,0,.823-28.362Zm-.823,26.362c-6.549,0-11.677-5.158-12.2-12.265h0C36.467,24.652,45.783,14.473,48.6,11.778c.274.271.588.589,1.05,1.059.557.566,1.318,1.342,2.471,2.5-4.405,6.787-3.574,11.623-3.21,12.316a1.036,1.036,0,0,0,.9.551,12.193,12.193,0,1,1,0,24.386Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M15.114,26.226c-.13-1.39-.034-5.175,3.6-10.449A1,1,0,0,0,18.6,14.5c-1.477-1.477-2.392-2.409-3.033-3.062-.848-.863-1.234-1.257-1.8-1.77a1,1,0,0,0-1.328-.014A38.332,38.332,0,0,0,.1,40.468h0C.7,48.65,6.665,54.588,14.291,54.588a14.193,14.193,0,0,0,.822-28.362Zm-.822,26.362c-6.548,0-11.679-5.158-12.2-12.266h0C.953,24.649,10.268,14.472,13.082,11.778c.275.271.59.591,1.053,1.063.556.566,1.316,1.341,2.467,2.5-4.405,6.788-3.574,11.623-3.21,12.315a1.038,1.038,0,0,0,.9.552,12.193,12.193,0,1,1,0,24.386Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuotemarksLeft);
export default __webpack_public_path__ + "static/media/Quotemarks-left.1dfc2dc752c9ca9d68b41f2671085998.svg";
export { ForwardRef as ReactComponent };